import { Injectable, inject } from '@angular/core';
import { DataService } from '@core/services/data.service';
import { Observable } from 'rxjs';
import { IResource, IResourceRequest } from '../interfaces/iresource';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { IImpactVideoResponse } from '../interfaces/iimpact-video';
import { IFacilitationGuideAttachment } from '../interfaces/ifacilitation-guide';
import { IAttachmentUploadSasRequest } from '@core/interfaces/iattachment-opload-sas-request';
import { IAttachmentUploadSasResponse } from '@core/interfaces/iattachment-opload-sas-response';

const fileOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'multiform/form-data' }),
};

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  dataService = inject(DataService);
  private http = inject(HttpClient);

  getResources(): Observable<IResource[]> {
    return this.dataService.get(`resource/all`);
  }

  getResource(id: number): Observable<IResource> {
    return this.dataService.get(`resource/${id}`);
  }

  addResource(payload: FormData): Observable<boolean> {
    return this.dataService.post(`resource`, payload);
  }

  addImpactVideo(payload: FormData): Observable<boolean> {
    return this.dataService.post('impactvideo', payload);
  }

  getAllImpactVideos(): Observable<IImpactVideoResponse[]> {
    return this.dataService.get(`impactvideo/all`);
  }

  getImpactVideo(id: number): Observable<any> {
    return this.dataService.get(`impactvideo/${id}`);
  }

  deleteResource(id: number): Observable<boolean> {
    return this.dataService.delete(`resource/delete-resource?id=${id}`);
  }

  deleteImpactVideo(id: number): Observable<boolean> {
    return this.dataService.delete(`impactvideo/delete-video?id=${id}`);
  }

  saveAttachment(attachment: FormData): Observable<boolean>  {
    return this.dataService.post('resource/add-attachment', attachment);
  }

  getAttachments(): Observable<IFacilitationGuideAttachment[]> {
    return this.dataService.get(`resource/attachments`);
  }

  deleteAttachment(attachmentId: number): Observable<boolean> {
    return this.dataService.delete(`resource/delete-attachment?id=${attachmentId}`);
  }

   getAttachmentUploadSas(req: IAttachmentUploadSasRequest) {
    return this.dataService.postTyped<IAttachmentUploadSasResponse>(
      'resource/attachment-upload-sas',
      req
    );
  }

  saveAttachmentMetadata(dto: any) {
    return this.dataService.postTyped<boolean>(
      'resource/add-attachment-metadata',
      dto
    );
  }

  uploadFileToBlob(uploadUrl: string, file: File): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob'
    });

    return this.http.put(uploadUrl, file, {
      headers,
      reportProgress: true,
      observe: 'events'
    });
  }

}

